module.exports = __webpack_public_path__ + "static/media/orinocco61.4b259ed8.jpg";